import React from "react";
import videoLand from "../assets/videos/video_land.mp4";
//import videoPort from "../assets/videos/video_port.mp4";
import somethingBig from "../assets/images/descubre.svg";
import {isMobile} from "../utils";
import useStore from "../store";

interface OnBoardingProps {
  onStart: () => void;
}

const Onboarding: React.FC<OnBoardingProps> = ({onStart}) => {
  const isSceneLoaded = useStore<boolean>((state) => state.isSceneLoaded);

  return (
    <>
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        id="myVideo"
        //src={isMobile() ? videoLand : videoLand}
        src={videoLand}
      />

      <div className="absolute inset-0 bg-transparent-0 flex flex-col justify-center items-center bg-no-repeat bg-center bg-cover bg-torre-gray bg-opacity-50">
        <img className="w-64" src={somethingBig} alt="" />

        <button
          className="px-12 py-3 -mt-8 text-center uppercase tracking-widest bg-torre-pink text-white text-bold text-2xl"
          onClick={onStart}
          disabled={!isSceneLoaded}
        >
          {isSceneLoaded ? "Comenzar >" : "Cargando..."}
        </button>

        <div className="py-4 sm:py-8 px-8 lg:w-3/6 flex flex-col items-center">
          <h2 className="pt-4 sm:pt-8 uppercase font-extrabold text-xl text-center">
            Bienvenidos a La Torre Outlet
          </h2>
          <p>
            Comienza el Tour Virtual y podrás descubrir el Outlet de moda como
            nunca antes lo habías visto.
          </p>
        </div>
        {/* <div className="p-2 sm:p-4 absolute left-0 bottom-0 right-0 flex justify-center bg-black bg-opacity-75 text-white">
          <a
            className="py-2 smpy-3 px-10 sm:px-12 text-xs sm:text-sm bg-torre-pink"
            href="https://tourvirtual.latorreoutletzaragoza.com/bases/BASES_PARA_LA_PARTICIPACION_EN_EL_TOUR_VIRTUAL_DE_LA_TORRE_OUTLET_ZARAGOZA.pdf"
          >
            Consulta las bases del sorteo
          </a>
        </div> */}

        {/* {isMobile() ? (
          <div className="absolute bottom-0 left-0 righ-0 p-4 bg-black flex">
          <div className="mx-2 flex flex-col justify-between">
          <div className="my-2 bg-gray-700 text-gray-700">
          *************
          </div>
          <div className="my-2 bg-gray-700 text-gray-700">
          *************
          </div>
          </div>
          <p className="mx-2 text-2xs text-white">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque
          aut fugit officia praesentium id quae quaerat architecto non, quod
          dolorum nesciunt ex consectetur est unde commodi ipsam, doloribus
          ipsum itaque?Cumque odit cum commodi eligendi quae.
          </p>
          </div>
          ) : (
            <div className="absolute bottom-0 left-0 righ-0 p-4 bg-black flex">
            <div className="mx-2 bg-gray-700 text-gray-700">*************</div>
            <div className="mx-2 bg-gray-700 text-gray-700">*************</div>
            <p className="mx-2 text-2xs text-white">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque
            aut fugit officia praesentium id quae quaerat architecto non, quod
            dolorum nesciunt ex consectetur est unde commodi ipsam, doloribus
            ipsum itaque?Cumque odit cum commodi eligendi quae.
            </p>
            <div className="bg-gray-700 text-gray-700">*************</div>
            </div> 
          )}*/}
      </div>
    </>
  );
};

export default Onboarding;
